// 用户评价, 其中评价内容 content 不能超过63个字.
export let localCommentList = [
  {
    'account': 'Poeut',
    'star': 5,
    'head': 'data:image/jpg;base64,/9j/4AAQSkZJRgABAQIAJQAlAAD/2wCEAAgICAgJCAkKCgkNDgwODRMREBARExwUFhQWFBwrGx8bGx8bKyYuJSMlLiZENS8vNUROQj5CTl9VVV93cXecnNEBCAgICAkICQoKCQ0ODA4NExEQEBETHBQWFBYUHCsbHxsbHxsrJi4lIyUuJkQ1Ly81RE5CPkJOX1VVX3dxd5yc0f/CABEIADAAMAMBIgACEQEDEQH/xAAaAAACAwEBAAAAAAAAAAAAAAADBQIEBwAG/9oACAEBAAAAANdU5Rz31b61nCt0z80NTUcQkENTmNgAAxG0iEYo/wD/xAAYAQEBAAMAAAAAAAAAAAAAAAACAAEDBP/aAAgBAhAAAAAbcdiLr//EABgBAQEAAwAAAAAAAAAAAAAAAAIAAQME/9oACAEDEAAAAFruUI2P/8QAJxAAAgEEAQQCAQUAAAAAAAAAAQIDAAQRMQUQEiFBEyIUFSNRYZH/2gAIAQEAAT8AnseMULbPaqFfTBfY9Gv0x+Ks7qSJ8rtUq7lmllZm3mre1kfyGXVWtlD3JmTyfVD5YIsLsjVW3NWEzsfCvnPad+KmeK8+siAoy4xndc3BYQXItVcA7ONKDqvjt07Px5Fyd+a4+3RJoGeQZbyMHdX98ouo47fAYt2tScnJGJFSKP7grlh9sH+6TlLyGMRxylVBJq4kklcySOXY+yaFWVzHCrStIQ+gAPNQ3L3XJ2xZnOXA+u6+M7pt04o9ONuUtZxMV0jf6aaQn3qmNTd/Z+3jORv+OhxiiayKY4FHoen/xAAZEQEBAQEBAQAAAAAAAAAAAAABEQACIDH/2gAIAQIBAT8AjgZo2GeecGeSKffH/8QAGxEAAwACAwAAAAAAAAAAAAAAAAERAiESIDH/2gAIAQMBAT8A0N42FUObLuie0n50/9k=',
    'content': '线路多,速度快,看NETFIX很方便,而且客服回复速度也很快,偶尔有点小问题很快就能解决用了很久了,一直很稳定。',
    'date': '2021年3月28日'
  },
  {
    'account':'dusan peil',
    'star':5,
    'head':'data:image/jpg;base64,/9j/4AAQSkZJRgABAQIAJQAlAAD/2wCEAAgICAgJCAkKCgkNDgwODRMREBARExwUFhQWFBwrGx8bGx8bKyYuJSMlLiZENS8vNUROQj5CTl9VVV93cXecnNEBCAgICAkICQoKCQ0ODA4NExEQEBETHBQWFBYUHCsbHxsbHxsrJi4lIyUuJkQ1Ly81RE5CPkJOX1VVX3dxd5yc0f/CABEIADAAMAMBIgACEQEDEQH/xAAaAAEBAQEAAwAAAAAAAAAAAAAHBgUDAgQI/9oACAEBAAAAAHuHDfBXVZgAl0/skwgrffQJ5x9wEQXWSy+4qpb9Fsahec0Nci//xAAWAQEBAQAAAAAAAAAAAAAAAAABAgP/2gAIAQIQAAAAqVw0sP/EABYBAQEBAAAAAAAAAAAAAAAAAAEDAP/aAAgBAxAAAACbis8n/8QAMxAAAQMDAgMECAcBAAAAAAAAAgEDBAAFEQYSBxMiITFBYRQVMjNCUVKyEDRDU3OCwdL/2gAIAQEAAT8AJREVJVRESr/q9q3xX32s7A+PGVJV8BSp+ttRznjL1g603+00XYlRdZ6oie6ujpfyddaP4hesy9EuQCElBzvDuKhISRCRcotX+aX5YV6U6nP8StX3ZJk4YrRZaj5z8icphlyQ+yw17x1wQDPd1Lii0ukaLqRlltDVXWo8Yk6878IKj/Za1jYxs8S2XqDgHorvoz4/NEzsVa0zdEeAGs9DjaOM580ziuIF2kQmSbYXDkl40U/EQT5VhErh7alnXk30LCxGlND83MjUBiUywgSpKPmhe3sQftriMzJCwzHXX2zA5DPLDYKY6q0tK3xbQ8C5wLYr9qpWsrXap7RxpdxjxJIGrjBumiU+yUd9xkjbMgLbls94F5iqeFcNbhIjXSUw3DekMvAG8mv0iT2d1T5T8YB5UJx9V+lUTGK1daD1CxAtvPOL1LINeVzU6BxsPCp9daZ03PsqRYUt0TIpSkmz2cJXEbTbsgAvEUMuMhsfFPEB+KiASTqFFrRepLYFses90JloMKjZHgWzAu8SrQUmfIj3Np+6OTGIz6NRnTHqUPNan6gtFumR4DrmZDxiiNjlcb17N6+GaitEZ85wRTs6ETz71pK1Bw6jTDOTbHBjul2k0Xui/wCakaK1OwWFthmn1NEJpWmoWu7TGOHAtQNtuvK6bkjvyuB8Tq16JzcSu17fCTLI0c2Am1sTT8P/xAAbEQEBAAIDAQAAAAAAAAAAAAABAAIxAxEhcf/aAAgBAgEBPwADqUgE7J9PLPdxu/kJpssCMQL/xAAZEQEBAQEBAQAAAAAAAAAAAAABABECIQP/2gAIAQMBAT8AevcLCXG5D3bnnb6DsjukdJkq3//Z',
    'content':'冲鸭, 冲呀, 这个名字一听就很快!',
    'date':'2021年12月14日'
  },
  {
    'account':'小王子呀',
    'star':5,
    'head':'data:image/jpg;base64,/9j/4AAQSkZJRgABAQIAJQAlAAD/2wCEAAgICAgJCAkKCgkNDgwODRMREBARExwUFhQWFBwrGx8bGx8bKyYuJSMlLiZENS8vNUROQj5CTl9VVV93cXecnNEBCAgICAkICQoKCQ0ODA4NExEQEBETHBQWFBYUHCsbHxsbHxsrJi4lIyUuJkQ1Ly81RE5CPkJOX1VVX3dxd5yc0f/CABEIADAAMAMBIgACEQEDEQH/xAAbAAACAgMBAAAAAAAAAAAAAAAFBgMEAAIHAf/aAAgBAQAAAABnYpw7Tb57J7QJkAV/AZ84iLohyWH8WU1V3WvYOb87ZYf/xAAXAQEBAQEAAAAAAAAAAAAAAAACAAMB/9oACAECEAAAAMX0TzV//8QAFwEAAwEAAAAAAAAAAAAAAAAAAQIDBP/aAAgBAxAAAADYs6qGA//EACwQAAIBAwMDAgYCAwAAAAAAAAECAwAEEQUSIRNBUTFhFBUiM0JScaGxweH/2gAIAQEAAT8A027ubc7RK5wcOG9uDS6rKqbjJ/Gf8NQ1sx7TLFuT90NSTWtzfMxM6oSjMhUZJ8cEGo9StmHGQP48V8TBjPVFT38JvZFWNeTncR3NbOsVZkx/vFXIljXMcmxVkXfkdhSWhj1NJDKSzkMDnz2pZZ5nljLjGTh1/HFW1sy+GPkmooU+5OwGXzyfFGWHtKoz7+KkmgeWBl+rLclTxVzc9C/hjXlOs3/BWnxKkFooPLR7nz3c96iZUdWYfSPXjsa6LxlpLhQ7dkPoAa1Xqyo7WsYEu0q6cDcp/UmtBg1Wyv7YzRyRwuWV898+1JbCScMX7t6+vNX+t6vFqrQwmSK2RykSKv3AvGc981pt5em2h+JuB1eGdMDv2pEvblhJIoEhXjYT347kiotHn2LujRvXPOSc0lonVaGWPYccZHmofmC6g9icCffkccbTznP618tRkCBWCjwcDNW0CLOIkTbH+fGMnxWmyxTs4j9BSzdNAD6CpNtzCynuOD4PmrFNb+MaabY2RjjjgUsF9Py0vSB7IPHvR0eaNy0NxKG8lt/9Gv/EABkRAAMAAwAAAAAAAAAAAAAAAAABEQIhMf/aAAgBAgEBPwDCpQrFkxdOM2jVJEJM/8QAHBEBAAICAwEAAAAAAAAAAAAAAQACETEDEBIi/9oACAEDAQE/AOTzZykotH5cRoO46h0qOJWwbjYn/9k=',
    'content':'速度很快, 且稳定, 大大的赞',
    'date':'2022年3月1日'
  },
  {
    'account':'六六六',
    'star':5,
    'head':'data:image/jpg;base64,/9j/4AAQSkZJRgABAQIAJQAlAAD/2wCEAAgICAgJCAkKCgkNDgwODRMREBARExwUFhQWFBwrGx8bGx8bKyYuJSMlLiZENS8vNUROQj5CTl9VVV93cXecnNEBCAgICAkICQoKCQ0ODA4NExEQEBETHBQWFBYUHCsbHxsbHxsrJi4lIyUuJkQ1Ly81RE5CPkJOX1VVX3dxd5yc0f/CABEIADAAMAMBIgACEQEDEQH/xAAbAAACAwADAAAAAAAAAAAAAAADBgQFBwACCP/aAAgBAQAAAADXUTrKYLMPn9ntgaxBXVusatCjVi7y9Yo6iIx2UOXXhFzU/wD/xAAWAQEBAQAAAAAAAAAAAAAAAAAEBQb/2gAIAQIQAAAAl2s+pwhUQf/EABgBAAMBAQAAAAAAAAAAAAAAAAMEBgIF/9oACAEDEAAAANR9qAo+gsz/AP/EADEQAAICAAQFAgUBCQAAAAAAAAECAwQABRESBhMhIjEUkTJBQlFhFRYjUmJyoaKx8f/aAAgBAQABPwDYPsMcU8XrlBihoRRTz7/328diLht96OCzPdl7wrDlSNHH3DwqriBMxr2k9LYklJBPpp21VwP4WOpTGU5rRzeKR6+okicxzQuNHiceVbBQfYe2LkjwUrMydHWJtn9R8YzuKUTalCKoniimk8nV/wDegGM1mt1HqU6EaSJXWKRO7UsV8bjivnckubUZYK0scXLePR9OjnuPtpjgy69rP7dwOTHcnn6/fyV/suJBjMQPQSflox7uBivw7leapmFO2WO2zHOOW+1lJTaNcWeGZaBeKSSq0p3su0tu5Y8FvfEXD962IkaeKBOYQ7mTY20dGMbAtroMZDRqwXqnpoDDF6uTlxEMCiLCyKDu666DriQYlhM1aWMOFZkOjEa7W8g6fjFyvdShyIrCw2HnAjkB03f9x6fPhMjz161wxtuB5iKwI7vj1VsS184NkWFyaASBFG6ScE9OmvR1XGWVr8lqOa6sKSpK7lYv5k0Hj5ndriTAkCIWY6Ko1JwOJK2bxGeomw0rCTbZm2cxSCvTzhOLaKa83LHUbfol16Dt/GP2vyr4YcunY/YtiPiihUptfsxNGtixsREPMOioFws8ViKOaJw0ciBlI+oN1Bwx0XqNdfliTg2/+qMkCIKXMEgd+o0H06eemumK/BSRGvraB2QQRydnxtHJzGOH4NMlm3NJcUc0FU2p3xqX3dCT1IHTEnCGaJLl9EKHrIBvnX/I6E+2IY44YYoY1CpGgVQPkF6AY//EACIRAAEDAwMFAAAAAAAAAAAAAAEAAwQCERITMWEFIjJRUv/aAAgBAgEBPwDp8RpwVuO+I2HKqDdTengLKbE0axY3BF1FcAZw9oEDfNTK8yOBZRnQD3FCTR9qS8CTY3X/xAAkEQACAQQCAAcBAAAAAAAAAAABAgQAAxIhEUEFIlFSYXFykf/aAAgBAwEBPwCVNdZNqPbHJZSzfAFW4HiyXRNEu5jkTifbUOYL6trgqcT91cjgzFvc7wxpkk7QNYK/rjVQ4wjG6Muc3Lf2mQEMe+qCrhux5vTLVC2Aqnvuv//Z',
    'content':'比我想象中的要快很多, 连接后嗖嗖嗖的! 5星好评',
    'date':'2022年6月1日'
  },
  {
    'account':'Bored lol',
    'star':5,
    'head':'data:image/jpg;base64,/9j/4AAQSkZJRgABAQEASABIAAD/2wCEAAgICAgJCAkKCgkNDgwODRMREBARExwUFhQWFBwrGx8bGx8bKyYuJSMlLiZENS8vNUROQj5CTl9VVV93cXecnNEBCAgICAkICQoKCQ0ODA4NExEQEBETHBQWFBYUHCsbHxsbHxsrJi4lIyUuJkQ1Ly81RE5CPkJOX1VVX3dxd5yc0f/CABEIADAAMAMBIgACEQEDEQH/xAAbAAACAgMBAAAAAAAAAAAAAAAEBgMFAQIHAP/aAAgBAQAAAADtWdRqVw5rK2+BY11aZpKk3dUcLVfuwkrBNQ1wc6OliG//xAAWAQEBAQAAAAAAAAAAAAAAAAABAgD/2gAIAQIQAAAAo1y2v//EABYBAAMAAAAAAAAAAAAAAAAAAAABAv/aAAgBAxAAAAAYyZUf/8QAMxAAAgECBQIDBgQHAAAAAAAAAQIDBBEABRITISIxBhRCQVFhYnGRBxWBsSNSU6GywdL/2gAIAQEAAT8Au6PpXlMTTatyOJjqHBb2C/8AvA3la6FBfutie/1JxmVdWUVI88NC1Uw7pGbGw9oBxkFZnVXmM0lfMFUU2ry6jiPW3Tf48HHN1bt8PrjOJfEa5tNSwZrtRODJTfw05SwDLqt3UnHhiHPYamo/M6l3jRNEUQfWD6i+EqRuyKV5I1cm3c6cGokR+prB24+U4kn/AC6eorA8CiWNFYSsUUGO/q5sDq92IpDPTQylGTWqtpPsuL2x4lplnyyOIXWTeGyVOgiSxsQf8vlx4UzCprKOM1UqNOWbrUaQygab/wDQxvUe/HE0gFVIbxRDlmAuT2vx3xV0tVNGkQAKyERyMeCvzAWPWPscb9Q9KS8AmJRCNwcEjpfsp+uKePMlaGKgheChc86tAaK3tiQmwQ48TxQS0NJDI+iR6oaHHcAA67fVLjFHGlJU1bBzrpqjUYbjgT9Wpf04HxxDsirWYbYMvVrvbVbj9sVNbBTwtIXBPsUHkn3YoQ7yojNxEQx4uDrv/YYoa7eR1I4WVwh964zuWj2nWoRHZWi2g39Q9Vx9sZlFFN5nVaWRWj3WDGMggXaxFivcYy2SaSm8vP5gqV6DErPLGYxpu1uRb98VEOYxIgWs1hwCswphp56eTqN7/vjzlfS5rSUElRHvmTkx3UORZiOb4qKKnzNRBWV9VSVJF0VH27k+pP5sZu6ZhWakn0bReHWPTqFi/wBB2xqh8KZtBu1kconZ966mQlZeGOMt8SZZDUVQpK2tgWWTlECXdgvpV0LfpfGc+J6rLqyDy8+5DXATIVcqrBvV6QCcZpRylKKqpqpgkE8k0zxEXhiEWq63vwR9icZr+IObVcE0EVJFBTyjQGJ1uARbptpx/8QAHREAAwABBQEAAAAAAAAAAAAAAAERIQMQEiIyUf/aAAgBAgEBPwCYt3XkzUkNMSiouVqNTvJ8P//EABoRAQEBAAMBAAAAAAAAAAAAAAEAEQISIVH/2gAIAQMBAT8AxsmLcFWUbt7kngOtwU05ffL/2Q==',
    'content':'个人比较看好的一家, 服务质量很棒, 我是指速度 XD',
    'date':'2022年3月24日'
  },
  {
    'account':'Gmed',
    'star':5,
    'head':'data:image/jpg;base64,/9j/4AAQSkZJRgABAQIAJQAlAAD/2wCEAAgICAgJCAkKCgkNDgwODRMREBARExwUFhQWFBwrGx8bGx8bKyYuJSMlLiZENS8vNUROQj5CTl9VVV93cXecnNEBCAgICAkICQoKCQ0ODA4NExEQEBETHBQWFBYUHCsbHxsbHxsrJi4lIyUuJkQ1Ly81RE5CPkJOX1VVX3dxd5yc0f/CABEIADAAMAMBIgACEQEDEQH/xAAaAAACAwEBAAAAAAAAAAAAAAAFBwMEBgII/9oACAEBAAAAAFI9LayXpmP0rPiU2D2zwupbJDNY4TKIFCbDBYHnzgnmjG8WPcH/xAAXAQADAQAAAAAAAAAAAAAAAAADBAUB/9oACAECEAAAAMUrpgrDAz//xAAWAQEBAQAAAAAAAAAAAAAAAAADBAX/2gAIAQMQAAAAanPZYmWT/8QAMhAAAQMCBAMECQUAAAAAAAAAAQIDBAASBRETIQZBQhQiMZEHMlFTcXKBgqFSYWKSov/aAAgBAQABPwCfi+KYoVl+QQgAnTR3UeVT48OdhscMNraVHZaSHynuug8kg+skEVhBgIYsRCcBHrLAvuI57b16SGkDG41oyHYwfDLrVSFusG9pxaFe1JyqNxNPj5B5Db6f3FqvMUxFubdHtSlP9jlWKm/DIjZ8Dl5AVhaE9jatSAMuQriSQwnFtMupS7pNH7SsgHzrFuzGe+Y4Abu8ALQCNjtTiBnTLQSDt4aX4cFTlkxYg5FqsE3jLSeldekJ8Hidzuhemwyneo70NbmT7EZpATsSH1jP6LJqVZrOaaklGe1oIG/svzNLWDqpSrMLaNp/0KiT+14NhzyV53M5GsCIsk/MK4rKZXFuJhUhLSNYDVWCQkIQB0A069hEVJERpyY976QmxoH+DW+f3H6VOZfZkrQ/us97MdV3Oo0hWihXu12/SuEcSuYkwyrZo3I+CqwqUWnpCSQEaN5UekJqZLMuZJlKzzeeW5uf1m6oSA/OjM55BTqa4qW32qOlOVwaN2QplakJWoeGwIrCMSMKc270Hur+BrEseQxAm6R3fiFsH5lBJ/BouVBlCPMjvK9VC6mTHJkhx9zZSuQ5ZV//xAAgEQACAgIBBQEAAAAAAAAAAAABAgADBBEhBRITQVFh/9oACAECAQE/AM0KioqjUx7Ctuwu+IVW1QWE6gDpDMAbtb8E3MmvyUmYNXarMfcbmwfAJ//EAB8RAQACAgICAwAAAAAAAAAAAAEAAgMEETESIjNhcf/aAAgBAwEBPwDUVyj9y2Iy5bVbePLEaXQemaHyTa9bv7GaljHmr5dczfUzMOp//9k=',
    'content':'亲测可以用, 推荐一波',
    'date':'2022年4月26日'
  }
]

export function setComment (buttons, realCommentList) {
  let commentInfoPan = document.querySelectorAll('.comment-info')
  for (let i = 0; i < realCommentList.length; i++) {
    let butSpan = document.createElement('span')
    butSpan.setAttribute('class', 'butspan')
    butSpan.setAttribute('index', i.toString())
    buttons.appendChild(butSpan)

    let head = realCommentList[i]['head']
    let account = realCommentList[i]['account']
    let star = realCommentList[i]['star']
    let date = realCommentList[i]['date']
    let content = realCommentList[i]['content']

    let contentDiv = document.createElement('div')
    let headAccStartDateDiv = document.createElement('div')
    let headAccStartDiv = document.createElement('div')
    let dateDiv = document.createElement('div')
    let headDiv = document.createElement('div')
    let accStartDiv = document.createElement('div')
    let startsDiv = document.createElement('div')

    dateDiv.setAttribute('class', 'comment-date')

    headDiv.setAttribute('class', 'comment-info-item-tar')
    let headImg = document.createElement('img')

    headImg.src = head
    headDiv.appendChild(headImg)
    headAccStartDiv.appendChild(headDiv)

    let accountP = document.createElement('p')
    accountP.innerText = account
    accStartDiv.appendChild(accountP)

    if (star > 0 && star <= 5) {
      for (let j = 0; j < star; j++) {
        let starImg = document.createElement('img')
        starImg.setAttribute('class', 'star-img')
        starImg.src = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAqCAMAAAAQwSIQAAAAjVBMVEUAAAD/vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg+caxKyAAAALnRSTlMA3wLPCwcX+Ovj1H1CEfDc2MeUbGpcPDAUuqF2Z2NPKvLAsq2oSDclH+eah4RW24XdVgAAASNJREFUOMuV1ddygzAQQFGJbjCEjumusdP2/z8vClYwCSuz3Ec4w7A7jGBoRs1WlMHrCs0hWvNogJysHaFdKk7gpwsNa/tBc5r24F5GwaYt9RtFf8BvzTI2YCxY1jE8qpewD5PsheX1R5j2ftVwaOVpfNjA/3gZN/luOlfx5Z1CG9TZ7tnrelNYjztAy+Epy4FcUIgtcCLWxcRkrptsaMepGOc4HvmGjkXWc+4KTOauwRjCqVjwUIF1gyEVCm0xrK1C96iuFTpDdaXQHqojha4wrDkKHWH6Boocjb4S0Q0/WR8FMGn7/NiJOj/hMNYiugTZoRuGTl5A9oloebO8jEtK5aXTHPs2iI5/3/HudXwl5/l/rwkBYP4RtkFVMKw23F+Z7BsmTZQo/7MF/wAAAABJRU5ErkJggg=='
        startsDiv.appendChild(starImg)
      }
      if ((5 - star) > 0) {
        for (let j = 0; j < (5 - star); j++) {
          let starImg = document.createElement('img')
          starImg.setAttribute('class', 'star-img')
          starImg.src = 'data:image/png;base64,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'
          startsDiv.appendChild(starImg)
        }
      }
    }
    accStartDiv.appendChild(startsDiv)
    headAccStartDiv.appendChild(accStartDiv)
    headAccStartDateDiv.appendChild(headAccStartDiv)

    let dateSpan = document.createElement('span')
    dateSpan.innerText = date
    dateSpan.setAttribute('class', 'from-lang')

    dateDiv.appendChild(dateSpan)
    headAccStartDateDiv.appendChild(dateDiv)

    contentDiv.innerText = content

    let hr = document.createElement('hr')

    let commentInfoItem = document.createElement('div')
    commentInfoItem.setAttribute('class', 'comment-info-item')
    commentInfoItem.appendChild(headAccStartDateDiv)
    commentInfoItem.appendChild(hr)
    commentInfoItem.appendChild(contentDiv)
    commentInfoPan[0].appendChild(commentInfoItem)

  }

  let butspanList = document.querySelectorAll('.butspan')
  let commentItem = document.querySelectorAll('.comment-info-item')
  let commentInfo = document.querySelectorAll('.comment-info')[0]


  // set comment event
  let thisindex = 0
  let isMove = false;
  let startX = 0;
  let distanceX = 0;

  let setButStyle = function (index) {
    butspanList.forEach(b => {
      if (b.attributes.index.nodeValue == index) {
        b.style.background = '#ffbe0f'
      }
    })
  }
  let clearButStyle = function () {
    butspanList.forEach(b => {
      b.style.background = '#f2f2f2'
    })
  }


  let showCommentRight = function (index, commentInfo) {
    commentInfo.style.animationName = 'show-comment-right-' + index
  }
  let showCommentLeft = function (index, commentInfo) {
    commentInfo.style.animationName = 'show-comment-left-' + index
  }

  // delimit function swiper for comments
  let bindSwiperEvent = function (dom, leftCallBack, rightCallback) {
    dom.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
    })

    dom.addEventListener('touchmove', function (e) {
      isMove = true;
      let moveX = e.touches[0].clientX;
      distanceX = moveX - startX;
    })

    dom.addEventListener('touchend', function (e) {
      if (isMove && Math.abs(distanceX) >= 3) {
        if (distanceX > 0) {
          rightCallback && rightCallback.call(this, e);
        } else {
          leftCallBack && leftCallBack.call(this, e);
        }
      }
      showNextOrPrev()
      isMove = false;
      startX = 0;
      distanceX = 0;
    })
  }

  // only not none show
  if (buttons.style.display != 'none') {
    commentItem.forEach(com => {
      bindSwiperEvent(com,
        function () {
          if (thisindex < realCommentList.length - 1) {
            thisindex++
            clearButStyle(thisindex)
            setButStyle(thisindex)
            showCommentRight(thisindex, commentInfo)
          }
        },
        function () {
          if (thisindex > 0) {
            thisindex--
            clearButStyle(thisindex)
            setButStyle(thisindex)
            showCommentLeft(thisindex, commentInfo)
          }
        }
      )
    })

    // button click event
    butspanList.forEach(b => {
      b.onclick = function () {
        clearButStyle()
        b.style.background = '#ffbe0f'
        if (thisindex >= b.attributes.index.nodeValue) {
          showCommentLeft(b.attributes.index.nodeValue, commentInfo)
        } else {
          showCommentRight(b.attributes.index.nodeValue, commentInfo)
        }
        thisindex = b.attributes.index.nodeValue
        showNextOrPrev()
      }
    })
  }
  let showNextOrPrev = function () {
    if (thisindex <= 0) {
      prev.style.display = 'none'
      next.style.display = 'flex'
    } else if (thisindex >= realCommentList.length - 1) {
      next.style.display = 'none'
      prev.style.display = 'flex'
    } else {
      prev.style.display = 'flex'
      next.style.display = 'flex'
    }

  }
  let prev = document.getElementById('prev')
  let next = document.getElementById('next')
  prev.onclick = function () {
    clearButStyle()
    thisindex--
    showCommentLeft(thisindex, commentInfo)
    setButStyle(thisindex)
    showNextOrPrev()
  }
  next.onclick = function () {
    clearButStyle()
    thisindex++
    showCommentRight(thisindex, commentInfo)
    setButStyle(thisindex)
    showNextOrPrev()
  }
  setButStyle(thisindex)
  showNextOrPrev()
}



